import { Routes, Route } from "react-router-dom";
import HeaderOora from "../Components/Oora/headerOora";
import ListOoraPlans from "../Components/Oora/ooraPlanList";
import ListOoraPayments from "../Components/Oora/ooraPaymentList";
const OoraPlanRoutes= () => {
  return (
    <Routes>
      <Route path="/oora" element={<HeaderOora/>}></Route>
      <Route path="/oora-plan" element={<ListOoraPlans/>}></Route>
      <Route path="/oora-payment-list" element={<ListOoraPayments/>}></Route>
    </Routes>
  );
};

export default OoraPlanRoutes

